import { FavoriteExamPrescriptionStruct } from "../../structs/medic/favorite-exam-prescription.struct";

export class FavoriteGroupExamPrescriptionRequest{
    public idDoctorFavoriteGroupExamPrescription: number;
    public doctorFavoriteGroupExamPrescriptionName: string;
    public listFavoriteExamPrescriptionStruct: FavoriteExamPrescriptionStruct[] = [];
    public shareWithMedicalTeam: boolean;
}